
<div class="grid-x">
    Legal language to display below the signature prompt:
</div>

<div [froalaEditor]="froalaOptions" [(froalaModel)]="componentData.config.display.legalFooter" (froalaModelChange)="onLegalFooterChange()"></div>